import { render, staticRenderFns } from "./myAlert.vue?vue&type=template&id=0de983b4&scoped=true"
import script from "./myAlert.vue?vue&type=script&lang=js"
export * from "./myAlert.vue?vue&type=script&lang=js"
import style0 from "./myAlert.vue?vue&type=style&index=0&id=0de983b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de983b4",
  null
  
)

export default component.exports